import React from 'react'
import robot from '../../Icons/robot.jpeg';
import Padding from '../Padding';
import AnimateOnScroll from '../../components/AnimateOnScroll';
import NavBar from '../NavBar';
import SEO from '../../components/SEO'
import Sales from '../Sales';

class RoboticsAutomation extends React.Component {
    render() {
      return (
        <div  id="RoboticsAutomation" style={{backgroundColor: '#101015'}}>

          <NavBar/>
          <Padding/>
          <Padding/>


            <div className="container-text" style={{padding:"30px"}}>
              
            <h2>Robotics and Automation</h2>

            <div className="float-right">
              <AnimateOnScroll direction="right" duration={600} delay={100}> 
                <img 
                  src={robot} 
                  style={{maxWidth:'400px'}} 
                  alt="Specialist services in industrial robotic arm programming and automation integration"
                  loading="lazy"
                />
              </AnimateOnScroll>
            </div>
              <div style={{padding:"10px"}}> 


            <p>Specialising in bespoke software development for controlling automation hardware offering a suite of services tailored to your unique needs.</p>

            <p>We can identify opportunities for automation. This can then be followed by design, prototyping and deployment of tailored solutions that optimise processes and enhance productivity</p>

            <p>Software can be built to control and manage diverse automation hardware and robotic systems. The software undergoes simulation and testing phases to validate performance and identify any potential issues before deployment. Monitoring and reporting features allowing for detailed analysis and optimisation.</p>

            <p>The systems will be easily upgradable as the client's needs evolve by design. We can also provide comprehensive documentation, training programs, maintenance and support services.</p>

            {/* <p>Beyond the initial development and implementation, we offer ongoing maintenance and support services to address any issues, apply updates, and ensure the continued reliability of any automation software.</p> */}

            </div> 



    <p>
        We specialise in these technologies:
    </p>

    <div className="usp-list">
        <div className="usp-item">
            <strong>Industrial Robotics (ABB)</strong>
            <span>
                Expertise in the programming and commissioning of major robotic 
                platforms, including path optimisation, payload calculations, 
                and seamless integration with external sensor arrays and vision systems.
            </span>
        </div>

        <div className="usp-item">
            <strong>Collaborative Robotics (Cobots)</strong>
            <span>
                Specialising in the deployment of fenceless robotic solutions using 
                Universal Robots or Techman Robots. We focus on safe human-robot interaction, 
                force-sensing calibration, and rapid redeployment.
            </span>
        </div>

        <div className="usp-item">
            <strong>PLC & HMI Development</strong>
            <span>
                Design and implementation of robust control logic using Siemens TIA 
                Portal, Rockwell Studio 5000, and Beckhoff TwinCAT, featuring 
                intuitive HMI interfaces for real-time process visualisation.
            </span>
        </div>

        <div className="usp-item">
            <strong>Motion Control & Servos</strong>
            <span>
                Precision tuning of multi-axis coordinated motion, utilising 
                advanced servo drives and actuators to achieve high-speed 
                repeatability and synchronisation across complex mechanical assemblies.
            </span>
        </div>

        <div className="usp-item">
            <strong>Fieldbus & Industrial Networks</strong>
            <span>
                Specialising in the deployment and troubleshooting of industrial 
                communication protocols, including Profinet, EtherNet/IP, and 
                EtherCAT for low-latency hardware interoperability.
            </span>
        </div>
    </div>





            </div> 



          <Padding/>
          <Padding/>
          <Sales/>
          <SEO/>
        </div> 

      )
    }
  }

  export default RoboticsAutomation;

